<template>
    <div class="mt-8 py-2">
        <div
            @click="$emit('closed')"
            class="btn btn-square btn-sm btn-ghost absolute top-0 right-0 m-1 close-z-100"
        >
            <span class="material-symbols-outlined notranslate fill-current">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    height="24"
                    viewBox="0 -960 960 960"
                    width="24"
                >
                    <path
                        d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"
                    />
                </svg>
            </span>
        </div>
        <div class="mb-1 mx-4 flex justify-between">
            <div class="text-lg font-extrabold m-1 pb-2 mx-2">
                {{ trans.routes.route_ttl }}
            </div>
            <div class="btn btn-sm rounded-full normal-case z-100" @click="closeDetail(), clearSearchInput(), isShowSuggestions = false">
                {{ trans.routes.clear }}
                <span v-if="currentRoute" class="inline-flex rounded-full h-3 w-3 bg-primary z-10"></span>
            </div>
        </div>
        <div class="mx-4">
            <div class="mt-3 my-2">
                <div class="relative w-full">
                    <div class="absolute z-10 my-2 ml-2 text-base-content opacity-60">
                        <span class="material-symbols-outlined notranslate fill-current">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"/></svg>
                        </span>
                    </div>
                    <div class="absolute z-10 right-0 mt-2 mr-2 text-base-content opacity-60" v-if="search.length > 0" @click="clearSearchInput(), isShowSuggestions = false, closeDetail()">
                        <span class="material-symbols-outlined notranslate fill-current">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>
                        </span>
                    </div>
                    <input
                        type="text"
                        name="search"
                        autocomplete="off"
                        placeholder="Search…"
                        class="input w-full input-sm h-10 input-bordered input-ml"
                        v-model.trim="search"
                        @focus="isShowSuggestions = true"
                        @keyup.delete="isShowSuggestions = true"
                        @input="handleSearchInput"
                    />
                </div>
            </div>

            <div class="results" v-if="isShowSuggestions && suggestions.length > 0">
                <div class="flex justify-between">
                    <div class="text-sm font-bold mt-2 pl-2 ml-4 text-base-content text-opacity-50">
                        {{ trans.search_box.keyword }}
                    </div>
                    <div class="btn btn-sm btn-link" @click="isShowSuggestions = false">
                        {{ trans.search_box.close }}
                    </div>
                </div>
                <div class="overflow-y-auto h-screen search-content-height">
                    <table class="table">
                        <tbody>
                            <tr
                                class="hover"
                                :class="{
                                    highlight: isHighlightClass && index == hoverSuggestion
                                }"
                                v-for="(suggestion, index) in suggestions"
                                :key="'search-suggestion' + index"
                                @mousedown="chooseSuggestion(suggestion)"
                                @mouseover="
                                    hoverSuggestion = index;
                                    isHighlightClass = true;
                                "
                                @mouseleave="isHighlightClass = false"
                                style="border-bottom-style: solid"
                            >
                                <td>
                                    <div class="flex items-center gap-3">
                                        <span class="material-symbols-outlined notranslate fill-current">
                                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="M784-120 532-372q-30 24-69 38t-83 14q-109 0-184.5-75.5T120-580q0-109 75.5-184.5T380-840q109 0 184.5 75.5T640-580q0 44-14 83t-38 69l252 252-56 56ZM380-400q75 0 127.5-52.5T560-580q0-75-52.5-127.5T380-760q-75 0-127.5 52.5T200-580q0 75 52.5 127.5T380-400Z"/></svg>
                                        </span>
                                        <div
                                            class="text-base-content text-sm break-words"
                                            style="overflow-wrap: anywhere"
                                        >
                                            {{ suggestion.title }}
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div class="text-center mt-2 mx-4" v-if="suggestions.length >= 20">
                        <div class="font-bold mb-2">{{ trans.search_box.show_maximum }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="overflow-y-auto h-screen routes-content-height">
            <div>
                <div
                    class="route-item flex-col-reverse"
                    @click="choose(route)"
                    v-for="route in routes"
                    :key="'route-' + route.id"
                    :id="'route-' + route.id"
                >
                    <a>
                        <div
                            class="card rounded m-2 shadow transition-all duration-200"
                            :class="{
                                'hidden':
                                    currentRoute &&
                                    currentRoute.id !== route.id &&
                                    currentRoute.id !== null,
                                'hover:scale-[1.02] hover:bg-base-200': !(
                                    currentRoute && currentRoute.id === route.id
                                )
                            }"
                        >
                            <div
                                class="card-body ml-1 p-0 py-3"
                                :style="{
                                    'border-style': 'solid',
                                    'border-left-width': '5px',
                                    'border-left-color': route.line_color
                                }"
                            >
                                <div v-if="route.image_url" class="mx-2"
                                    :class="{
                                            'w-route-img': !(
                                                currentRoute && currentRoute.id === route.id
                                            )
                                        }"
                                >
                                    <img :src="route.image_url" class="rounded-lg">
                                </div>
                                <div class="mx-2 my-2">
                                    <div>
                                        <div
                                            class="text-base-content mb-1 font-bold text-base break-words text-overflow-wrap"
                                        >
                                            {{ route.title }}
                                        </div>
                                        <div
                                            class="text-base-content/80 text-sm break-words text-overflow-wrap"
                                        >
                                            {{ route.sub_title }}
                                        </div>
                                    </div>
                                    <div
                                        class="text-base-content text-base text_overflow pb-0 break-words text-overflow-wrap mt-5"
                                        v-if="currentRoute && currentRoute.id === route.id"
                                    >
                                        <span v-readMore:150="route.description"></span>
                                    </div>
                                </div>
                                <div
                                    v-if="routeLocations.length > 0 && currentRoute.id === route.id"
                                    class="route-list"
                                >
                                    <div class="divider my-1 mx-2"></div>
                                    <table class="table overflow-visible p-0 floor-content-height">
                                        <tbody>
                                        <div class="ext-sm font-bold my-2 ml-4 text-base-content text-opacity-50">{{ trans.routes.related_to_route }}</div>
                                        <tr
                                            v-for="location in routeLocations"
                                            :key="'location-' + location.properties.id"
                                            :id="'location-' + location.properties.id"
                                            @click="chooseLocation(location.properties.id)"
                                            class="hover"
                                        >
                                            <td class="flex items-center space-x-2 px-2">
                                                <div class="">
                                                    <div
                                                        class="mask mask-squircle bg-base-content h-16 w-16 bg-opacity-10 p-px"
                                                    >
                                                        <img
                                                            :class="[location.properties.marker_style === 'icon' || location.properties.marker_style === 'point' ? 'bg-primary' : 'bg-base-100']"
                                                            :style="
                                                                ((location.properties.marker_style === 'icon' || location.properties.marker_style === 'point') && location.properties.category.use_custom_color)
                                                                && 'background-color:' + location.properties.category.color
                                                            "
                                                            class="mask mask-squircle w-full h-full object-cover"
                                                            :src="location.properties.marker_image_url"
                                                        />
                                                    </div>
                                                </div>
                                                <div>
                                                    <div class="text-sm font-bold">
                                                        {{ location.properties.title }}
                                                    </div>
                                                    <div class="text-base-content/70 text-xs">
                                                        {{ location.properties.sub_title }}
                                                    </div>
                                                    <div class="btn btn-xs disabled rounded-full normal-case">
                                                        {{ location.properties.category.title }}
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </a>
                </div>
                <div class="text-center mt-4 mx-4" v-if="currentRoute">
                    <button
                        class="btn btn-circle z-100 relative"
                        @click="closeDetail(), clearSearchInput(), isShowSuggestions = false"
                    >
                        <span class="material-symbols-outlined notranslate fill-current">
                            <svg xmlns="http://www.w3.org/2000/svg" height="24" viewBox="0 -960 960 960" width="24"><path d="m256-200-56-56 224-224-224-224 56-56 224 224 224-224 56 56-224 224 224 224-56 56-224-224-224 224Z"/></svg>                                </span>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import * as turf from '@turf/turf';
import RouteHelper from '../mixins/Route';
import BottomSheet from './BottomSheet';
import ReadMoreDirective from '../custom_directives/ReadMore';

export default {
    inject: ['mapId', 'locale'],
    mixins: [RouteHelper],
    directives: {
        readMore: ReadMoreDirective
    },
    components: {
        BottomSheet
    },
    props: {
        mySmartMap: {
            type: Object,
            required: false
        },
        filterLocationsByRoute: {
            type: Function,
            required: true
        },
        showListRoute: {
            type: Boolean,
            required: true
        },
        trans: {
            type: Object,
            required: true
        },
        routeLocations: {
            type: Array,
            default: function () {
                return [];
            }
        },
        currentLayer: {
            type: Object,
            default: function () {
                return null;
            },
        },
        categoryId: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            routes: [],
            currentRoute: null,
            search: '',
            suggestions: [],
            hoverSuggestion: '',
            isHighlightClass: false,
            isShowSuggestions: false,
        };
    },
    created() {
        this.getRoutes();
    },
    methods: {
        transformCamera(coordinates) {
            var line = turf.lineString(coordinates[0]);
            var bbox = turf.bbox(line);
            const newCameraTransform = this.mySmartMap.cameraForBounds(bbox, {
                padding: { top: 10, bottom: 35, left: 15, right: 15 }
            });
            this.mySmartMap.flyTo(newCameraTransform);
        },
        getRoutes() {
            const layerParam = this.currentLayer?.id ? `&layer_id=${this.currentLayer.id}` : '';
            axios
                .get(`/api/maps/${this.mapId}/routes?locale=${this.locale}${layerParam}`)
                .then((response) => {
                    this.routes = response.data;
                    this.$emit('showRouteBtn', this.routes.length > 0);
                    this.getRouteOnParam();
                })
                .catch((error) => {
                    console.log(error.toJSON());
                });
        },
        choose(route) {
            this.currentRoute = route;
            this.showRoute(this.currentRoute);
        },
        scrollToLeft(value) {
            this.$refs.scrollContainer.scrollLeft += value;
        },
        closeDetail() {
            if (!this.currentRoute) {
                return;
            }
            this.hideRoute(this.currentRoute);
            this.currentRoute = null;
            this.addRouteParamToURL();
            this.filterLocationsByRoute(this.currentRoute);
        },
        getRouteOnParam() {
            const params = new URLSearchParams(window.location.search);
            this.currentRoute = this.routes.find((e) => {
                return e.id == params.get('route');
            });
        },
        chooseLocation(id) {
            this.$emit('chooseLocation', id);
        },
        addRouteParamToURL() {
            const routeId = this.currentRoute?.id;
            let routeQuery = routeId && routeId > 0 ? `?route=${routeId}` : '';
            const newUrl = window.location.pathname + routeQuery + (!this.categoryId ? '' : (!routeQuery ? `?c=${this.categoryId}` : `&c=${this.categoryId}`));
            window.history.replaceState(null, null, newUrl);
        },
        chooseSuggestion(payload) {
            // this.triggerEventGA('searched_keyword', {
            //     id: payload,
            //     title: payload
            // });
            this.choose(payload);
            this.isShowSuggestions = false;
            this.clickedSuggestion = true;
        },
        handleSearchInput() {
            if (this.search === '') {
                this.resetSuggestions();
            }
        },
        resetSuggestions() {
            this.suggestions = [];
        },
        hirakana (str) {
            return str.replace(/[ァ-ヶ]/g, function (c) {
                return String.fromCharCode(c.charCodeAt(0) - 0x60)
            })
        },
        katakana (str) {
            return str.replace(/[ぁ-ん]/g, function (c) {
                return String.fromCharCode(c.charCodeAt(0) + 0x60)
            })
        },
        sortTitle(results) {
            return results.sort(function (a, b) {
                var nameA = a.title.toUpperCase();
                var nameB = b.title.toUpperCase();
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }

                return 0;
            });
        },
        clearSearchInput() {
            this.search = '';
        },
    },
    watch: {
        currentRoute(newVal, oldVal) {
            this.mySmartMap.once('idle', () => {
                this.filterLocationsByRoute(newVal);
            });
            if (newVal) {
                this.showRoute(newVal);
                this.transformCamera(newVal.coordinates);
                this.$emit('toggledSubSidebar', 'routeBox');
                this.addRouteParamToURL();
                if (newVal.add_circle_and_flag) {
                    this.addStartPoint(newVal);
                    this.addEndPoint(newVal);
                    this.addAnimation(newVal);
                }
            }
            if (oldVal) {
                this.hideRoute(oldVal);
            }
        },
        currentLayer() {
            this.getRoutes();
        },
        search(newVal) {
            if (!newVal) return;
            var invalid = /[^a-zA-Z0-9\s]+/g;
            var sanitizedNewval = newVal.replace(invalid, '\\$&');
            var hirakanaNewVal = this.hirakana(sanitizedNewval);
            var katakanaNewVal = this.katakana(sanitizedNewval);

            let results = [];

            const pattern = new RegExp('(' + `${sanitizedNewval}` + '|' + `${hirakanaNewVal}` + '|' + `${katakanaNewVal}` + ')', 'i');

            results = this.routes.filter(function(item) {
                if (this.count < 20) {
                    if (pattern.test(item.title) || pattern.test(item.sub_title) || pattern.test(item.description)
                        || item.location_titles.find((element) => pattern.test(element))
                    ) {

                        this.count++;
                        return true;
                    }
                }
                return false;
            }, {count: 0});

            this.suggestions = this.sortTitle(results);
        },
    }
};
</script>

<style>
.w-route {
    width: 16rem;
    overflow-wrap: anywhere;
    text-align: start;
}
.text-overflow-wrap {
    overflow-wrap: anywhere;
}
.routes-content-height {
    padding-bottom: 40rem;
}
.w-route-img {
    width: 7rem;
}
.mapboxgl-popup-content {
    padding: 0px;
    background: none;
}
.popup-bg-opacity-80 {
    --tw-bg-opacity: 0.8;
}
.mapboxgl-popup-anchor-bottom .mapboxgl-popup-tip {
    border-top-color: rgb(255 255 255 / 50%);
}
.mapboxgl-popup-anchor-right .mapboxgl-popup-tip {
    border-left-color: rgb(255 255 255 / 50%);
}
.mapboxgl-popup-anchor-left .mapboxgl-popup-tip {
    border-right-color: rgb(255 255 255 / 50%);
}
.mapboxgl-popup-anchor-top .mapboxgl-popup-tip {
    border-bottom-color: rgb(255 255 255 / 50%);
}
.mapboxgl-popup-close-button {
    top: -7px;
    right: -6px;
    width: 24px;
    height: 24px;
}
.end-icon{
    left: 13px;
    top: -18px;
}
.start-icon{
    top: -16px;
    left: -9px;
}
@media screen and (max-width: 639px) {
    .routes-content-height {
        min-height: 40rem;
        padding-bottom: 40rem;
    }
}
</style>
